import React, { createContext, useState } from "react";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => {
    return localStorage.getItem("auth_token");
  });

  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem("auth_user");
    if (!savedUser) return null;
    try {
      return JSON.parse(savedUser);
    } catch {
      return null;
    }
  });


  const login = (newToken, userData) => {
    setToken(newToken);
    setUser(userData);
    localStorage.setItem("auth_token", newToken);
    localStorage.setItem("auth_user", JSON.stringify(userData));
  };


  const updateUser = (partialUser) => {
    setUser((prev) => {
      const next = { ...(prev || {}), ...partialUser };
      localStorage.setItem("auth_user", JSON.stringify(next));
      return next;
    });
  };



  const logout = () => {
    setToken(null);
    setUser(null);
    localStorage.removeItem("auth_token");
    localStorage.removeItem("auth_user");
  };

  const value = {
    token,
    user,
    isAuthenticated: !!token,
    login,
    logout,
    updateUser,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export default AuthContext;

